const messages = {
  en: {
    vendedor: {
      validation: {
        comisionMin: 'Commission cannot be less than 0%',
        comisionMax: 'Commission cannot exceed 100%',
        nombreRequerido: 'Name is required',
        apellidoRequerido: 'Last name is required',
        duplicado: 'A salesperson with this name and last name already exists',
      },
      labels: {
        nombre: 'Name',
        apellido: 'Last name',
        email: 'Email',
        telefono: 'Phone',
        comision: 'Commission (%)',
        activo: 'Active',
      },
    },
  },
  es: {
    vendedor: {
      validation: {
        comisionMin: 'La comisión no puede ser menor a 0%',
        comisionMax: 'La comisión no puede ser mayor a 100%',
        nombreRequerido: 'El nombre es requerido',
        apellidoRequerido: 'El apellido es requerido',
        duplicado: 'Ya existe un vendedor con ese nombre y apellido',
      },
      labels: {
        nombre: 'Nombre',
        apellido: 'Apellido',
        email: 'Email',
        telefono: 'Teléfono',
        comision: 'Comisión (%)',
        activo: 'Activo',
      },
    },
  },
  pt: {
    vendedor: {
      validation: {
        comisionMin: 'A comissão não pode ser menor que 0%',
        comisionMax: 'A comissão não pode ser maior que 100%',
        nombreRequerido: 'O nome é obrigatório',
        apellidoRequerido: 'O sobrenome é obrigatório',
        duplicado: 'Já existe um vendedor com esse nome e sobrenome',
      },
      labels: {
        nombre: 'Nome',
        apellido: 'Sobrenome',
        email: 'Email',
        telefono: 'Telefone',
        comision: 'Comissão (%)',
        activo: 'Ativo',
      },
    },
  },
}

export default messages
